import React from "react";

import "./SeeAllButton.scss";

import leftChevronImg from "../../assets/img/arrow_back.svg";

export default function SeeAllButton() {
  return (
    <div className="see-all-button__wrapper">
      <span className="see-all-button__chevron"><img src={leftChevronImg} alt="Back arrow" className="img-fluid" /></span>  
      <a href="/learn/interactive/" className="see-all-button__link">

        See All Learning Experiences
      </a>
    </div>
  );
}
